import React from 'react';
import { useSelector } from 'react-redux';
import {
  percent, _t, formatNumber,
} from 'utils';
import PropertiesTableComponent from 'screens/shared/properties-table';
import Progress from 'screens/shared/progress-bar';
import shared from 'screens/shared';
import { ACTIONS_TYPES } from 'redux/helper';
import { getResourceLimitsForContract } from 'utils/contract';

const _n = (no) => formatNumber(no);

export default () => {
  const { [ACTIONS_TYPES.CONTRACT.GET_ALL]: contracts = [] } = useSelector((e) => e);
  const resourceLimits = getResourceLimitsForContract(contracts);

  const {
    coresProvisioned,
    coresPerContract,
    ramProvisioned,
    ramPerContract,
    hddVolumeProvisioned,
    hddLimitPerContract,
    ssdVolumeProvisioned,
    ssdLimitPerContract,
    reservedIpsInUse,
    reservedIpsOnContract,
    k8sClustersProvisioned,
    k8sClusterLimitTotal,
  } = resourceLimits;

  const _b = (num) => num / 1024;

  const generateRow = ([title = '', valueProp = 0, totalProp = 0, isByte = false]) => {
    const isEmpty = !valueProp && !totalProp;
    const [value, total] = isByte ? [_b(valueProp), _b(totalProp)] : [valueProp, totalProp];
    const avg = isEmpty ? 0 : percent(value, total);
    return [
      title,
      <Progress
        value={avg}
        title={`${_n(value)}${isByte ? 'GB' : ''} / ${_n(total)}${isByte ? 'GB' : ''} ${isEmpty ? '' : `( ${Math.floor(avg)}% )`}`}
      />,
    ];
  };

  const keyMapper = (label, icon) => (
    <span>
      <shared.widgets.Icon name={icon} style={{ color: '#5e5e5e' }} />
      <span style={{ fontSize: 15 }}>{` ${_t(label)}`}</span>
    </span>
  );

  let contractDetails = [
    [keyMapper('Cores', 'microchip'), coresProvisioned, coresPerContract],
    [keyMapper('RAM', 'memory'), ramProvisioned, ramPerContract, true],
    [keyMapper('HDD', 'hdd'), hddVolumeProvisioned, hddLimitPerContract, true],
    [keyMapper('SSD', 'hdd'), ssdVolumeProvisioned, ssdLimitPerContract, true],
    [keyMapper('IPs', 'network-wired'), reservedIpsInUse, reservedIpsOnContract],
    [keyMapper('K8S', 'star-of-life'), k8sClustersProvisioned, k8sClusterLimitTotal],
  ];

  contractDetails = contractDetails.map(generateRow);

  return (
    <PropertiesTableComponent
      rowWidth={100}
      title={_t('Contract Details')}
      properties={contractDetails}
    />
  );
};
